<div class="modal-header">
    <h3 class="modal-title">{{ title }}</h3>
    <div class="header-actions">
        <i class="fa" 
           [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
           style="margin-right: 10px; cursor: pointer;"
           (click)="minimise=!minimise"></i>
        <i (click)="cancel()"
            class="fa fa-times" 
            id="FTC_BTCMT_CRUD_1"
            style="cursor: pointer;"></i>
    </div>
</div>
<div class="modal-body" [hidden]="minimise">
    <div>
        <form name="calculation901ReasonForm" id="calculation901ReasonForm"
            novalidate autocomplete="off">
            
            <!-- Loader -->
            @if (loadingData) {
<div class="formLoader">
                <i class="fa fa-spinner fa-spin gt-refresh"></i>
            </div>
}
            
            @if (!loadingData) {
<div>
                <div class="row">
                    <div class="form-group">
                        <label class="col-md-1 control-label"> 
                            <strong>Comments:</strong>
                        </label>
                        <div class="col-md-6">
                            <textarea class="form-control" 
                                      name="comments" 
                                      id="FTC_BTCMT_CRUD_2"
                                      [(ngModel)]="COMMENTS" 
                                      required 
                                      maxlength="3998"></textarea>
                            <div class="textarea_allowed">Max 4000</div>
                        </div>
                    </div>
                </div>

                <div class="row row-mt-10">
                    <div class="col-md-12" class="table table-hover table-bordered table-striped table-condensed">
                        <table class="table table-bordered" style="text-align: left;table-layout: fixed;">
                            <thead>
                                <tr>
                                    <th width="70%">Comment</th>
                                    <th width="15%">Logged By</th>
                                    <th width="15%">Logged On</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (comment of allComments; track trackByComment($index, comment)) {
<tr>
                                    <td style="word-wrap: break-word">{{ comment.COMMENTS }}</td>
                                    <td>{{ comment.LOGGED_BY }}</td>
                                    <td>{{ comment.LOGGED_ON }}</td>
                                </tr>
}
                                @if (allComments.length === 0 && !loadingData) {
<tr>
                                    <td colspan="3" style="text-align: center; padding: 20px;">
                                        No comments found
                                    </td>
                                </tr>
}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <br>
                </div>
            </div>
}

            @if (!ReturnAsFiled && !loadingData) {
<div class="modal-footer">
                <button id="FTC_BTCMT_CRUD_3" 
                        class="save-button" 
                        type="button" 
                        [disabled]="isSaveClicked || crudLoading"
                        (click)="save()">
                    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
                    Save
                </button>
                <button id="FTC_BTCMT_CRUD_4" 
                        class="cancel-button" 
                        type="button"
                        (click)="cancel()">Cancel</button>
            </div>
}
        </form>
    </div>
</div>

